module.exports = "<chart [options]=\"options\" (load)=\"savePieInstance($event.context)\"></chart>"


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/pie-chart/pie-chart.component.html
// module id = ../../../../../src/app/shared/components/graphs/pie-chart/pie-chart.component.html
// module chunks = main